<!-- 兑换记录 -->
<template>
  <div class="content">
      <div class="bodycontent">
          <div class="top">
            <!-- <div class="title">
              满减送
            </div> -->
            <div class="box">
              <el-card shadow="never" class="box-card">
                <div class="tit">
                  满N元减送
                </div>
                <div class="secondtit">
                   例：满100元减十元
                   可帮商家提高客单价
                </div>
                <el-button type="primary" @click="go(1)">立即创建</el-button>
              </el-card>
              <el-card shadow="never" class="box-card">
                <div class="tit">
                  满N件减送
                </div>
                <div class="secondtit">
                   例：满3件送1件
                   可帮商家清理库存
                </div>
                <!-- <router-link to="adActivity">
                  <el-button type="primary" icon="el-icon-plus">
                    立即创建 
                  </el-button>
                </router-link> -->
                <el-button type="primary" @click="go(2)">立即创建</el-button>
              </el-card>
              <el-card shadow="never" class="box-card">
                <div class="tit">
                  更多满减/送
                </div>
                <div class="secondtit">
                   敬请期待
                </div>
                <el-button type="text">告诉我们更好地玩法</el-button>
              </el-card>
            </div>
          </div>
          <div class="cont">
            <div class="filtter">
              <div class="">
                活动名称：
                <el-select v-model="value" placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="">
                活动类型：
                <el-select v-model="value" placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="">
                活动状态：
                <el-select v-model="value" placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <el-table
              :data="tableData"
              style="width: 100%">
              <el-table-column
                prop="name"
                label="活动名称"
                width="180">
              </el-table-column>
              <el-table-column
                label="类型"
                width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.full_type ==1">满N元减/送</div>
                  <div v-if="scope.row.full_type ==2">满N件减/送</div>
                 
                </template>
              </el-table-column>
              <el-table-column
                label="活动详情"
                width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.full_type ==1 && scope.row.dec_price_status == 1" >满{{scope.row.total_money}}元减{{scope.row.dec_price}}元</div>
                  <div v-if="scope.row.full_type ==2 && scope.row.free_status == 1 ">满{{scope.row.total_num}}件送{{scope.row.free_num}}件</div>
                  <div v-if="scope.row.full_type ==1 && scope.row.zhe_status == 1" >满{{scope.row.total_money}}元打{{scope.row.zhe_num}}折</div>
                  <div v-if="scope.row.full_type ==2 && scope.row.zhe_status == 1 ">满{{scope.row.total_num}}件打{{scope.row.zhe_num}}折</div>
                 
                </template>
              </el-table-column>
              <el-table-column
                label="活动时间">
                <template slot-scope="scope">
                  {{ scope.row.start_time}} - {{ scope.row.end_time}}
                </template>
              </el-table-column>
              <el-table-column
                prop="type"
                label="参与客户">
                </el-table-column>
              <el-table-column
                prop="type"
                label="实付金额(元)">
                </el-table-column>
              <el-table-column
                prop="type"
                label="笔单价(元)">
                </el-table-column>
              <el-table-column
                label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handle(1,scope.row.id, scope.row.full_type)">编辑</el-button>
                  <el-button size="mini" @click="handle(0,scope.row.id)">删除</el-button>
                </template>
                  
              </el-table-column>
            </el-table>
            
          </div>
      </div>
  </div>
</template>

<script>
import { fullReductList, deletefullReduct } from "@/api/fullReduction";
import { mapGetters } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["app_id", "token"])
  },
  data () {
    return {
      data: "",
      screenInput: "",
      tableData: [],
      value: "",
      options: [
        {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }
      ]
    };
  },

  components: {},
  mounted(){
    this.getList();
  },
  methods: {
    // 筛选
    screen(){
      console.log("screenInput", this.screenInput);
      let data = {
        token: this.token,
        app_id: this.app_id,
        type: this.screenInput,
        store_id: 0, //
      }
      fullReductList(data).then(res => {
        console.log("订单列表", res);
        this.tableData = res.data.result;
      })
    },
    getList(){
      let data = {
        token: this.token,
        app_id: this.app_id,
        store_id: 0, //
      }
      fullReductList(data).then(res => {
        console.log("订单列表", res);
        this.tableData = res.data.result;
      })
    },
    go(fullType){
      this.$router.push({ name: "adActivity", query: { fullType: fullType } });
    },
    // 操作 type 1 编辑 0 删除 index =>对应商品id
    handle(type, index, jude= 0) {
      if(type == 1){
        this.$router.push({ name: "adActivity", query: { idE: index, fullType: jude } });
      }else{
        let data = {
          token: this.token,
          app_id: this.app_id,
          store_id: 0, //
          id: index
        }
        deletefullReduct(data).then( res => {
          console.log("shanchu ", res)
          if(res.code == 200){
            this.$message.success(res.msg);
            this.reload();
          }else{
            this.$message("删除失败");
          }
        })
      }
      
    },
  }
}
</script>
<style lang= 'scss' scoped>
@import "./public/style/_interfacePublic";
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.padding {
  padding: 20px;
}
.content{
  width: 100%;
  .bodycontent {
    height: 100%;
    overflow: auto;
    .top {
      height: 200px;
      padding: 20px 0;
      .box{
        display: flex;
        justify-content: space-around;
        .box-card {
          width: 30%;
          text-align: center;
          color: #606266;
          /* background:　#b3d8ff; */
          background-color: #F2F6FC;
          .tit{
            font-size: 18px;
          }
          .secondtit{
            /* height: 30px; */
            padding: 12px 0;
          }
        }
      }
    }
    .cont{
      height: calc(100% - 80px);
      .filtter{
        display: flex;
        justify-content: space-between;
        padding: 40px 0;
      }
      .table{
        border: 1px solid #eeeeee;
        .title{
          height: 60px;
          line-height: 60px;
          background: #f5f7fa;
        }
        .list{
          padding: 20px 0 20px;
          .box{
            border: 1px solid #f1f1f1;
            .bianhao{
              height: 40px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: #f5f7fa;
            }

          }
        }
      }
    }
  }
}
</style>